const e = {
  name: "FormulaDifferentPeople",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M23,38h-6v2h6V38z"/>
		<path class="st0" d="M39,2.6L37.4,1c-1.3-1.3-3.5-1.3-4.8,0L28,5.6v5l-1,1c-2-1.7-4.4-2.6-7-2.6c-1.9,0-3.6,0.5-5.2,1.4L7.4,3
			C6.1,1.7,3.9,1.7,2.6,3L1,4.6C0.3,5.2,0,6.1,0,7s0.3,1.8,1,2.4l8.2,8.3C9.1,18.4,9,19.2,9,20c0,4.1,2.3,7.9,6,9.8V36h10v-6.2
			c3.7-1.9,6-5.6,6-9.8h-2c0,3.6-2.1,6.8-5.4,8.2L23,28.5V34h-6v-5.5l-0.6-0.3C13.1,26.8,11,23.5,11,20c0-0.7,0.1-1.4,0.2-2h3.3l2,2
			H18c0-0.4,0.1-0.8,0.3-1.1c0.4-0.5,1-0.9,1.7-0.9c1.1,0,2,0.9,2,2s-0.9,2-2,2h-1v5h2v-3.1c1.7-0.4,3-2,3-3.9c0-2.2-1.8-4-4-4
			c-1.2,0-2.4,0.6-3.1,1.5L16,16.5v-4.6c1.2-0.6,2.6-1,4-1c2.4,0,4.7,0.9,6.4,2.6l0.7,0.7l2.3-2.3h5L39,7.4c0.6-0.6,1-1.5,1-2.4
			S39.7,3.2,39,2.6L39,2.6z M9.6,8L6,11.6L4.4,10L8,6.4L9.6,8z M2.4,6L4,4.4c0.5-0.5,1.5-0.5,2,0L6.6,5L3,8.6L2.4,8
			C2.2,7.7,2,7.3,2,7C2,6.6,2.2,6.2,2.4,6z M14,16h-3.6l-3-3L11,9.4l3,3V16z M37.6,6l-4,4H30V6.4l4-4c0.5-0.5,1.5-0.5,2,0L37.6,4
			C37.9,4.2,38,4.6,38,5C38,5.3,37.9,5.7,37.6,6z"/>
	</g>
</g>
</svg>
  `
};
export {
  e as FormulaDifferentPeople
};
